import { Box, Button, TextField } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import type { FormEvent } from 'react';

import { getClientsPageTokens } from '../getClientsPageTokens';
import { CLIENTS_PAGE_LAYOUT_SIZES } from '../clientsTokens';

export interface AddMemberFormProps {
  disabled: boolean;
  memberEmail: string;
  onMemberEmailChange: (value: string) => void;
  onSubmit: (event: FormEvent) => void;
}

export function AddMemberForm({
  disabled,
  memberEmail,
  onMemberEmailChange,
  onSubmit,
}: AddMemberFormProps): JSX.Element {
  const theme = useTheme();
  const tokens = getClientsPageTokens(theme);

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', flexWrap: 'wrap' }}
    >
      <TextField
        value={memberEmail}
        onChange={(event) => onMemberEmailChange(event.target.value)}
        placeholder="person@example.com"
        label="Member email"
        size="small"
        fullWidth
        sx={{
          flex: '1 1 200px',
          '& .MuiOutlinedInput-root': {
            borderRadius: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarFieldRadius}px`,
            bgcolor: tokens.toolbarFieldBg,
            '& fieldset': { border: 'none' },
          },
          '& .MuiInputLabel-root': { color: tokens.bodySecondaryColor },
        }}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={disabled || !memberEmail.trim()}
        startIcon={<AddOutlined />}
        sx={{
          flexShrink: 0,
          minHeight: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarControlHeight}px`,
          height: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarControlHeight}px`,
          px: 2,
          borderRadius: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarFieldRadius}px`,
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '16px',
          bgcolor: tokens.primaryButtonBg,
          color: tokens.primaryButtonColor,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: tokens.primaryButtonHoverBg,
            boxShadow: 'none',
          },
        }}
      >
        Add member
      </Button>
    </Box>
  );
}
